export const appData = {
  orgFields: [
    {
      key: 'name',
      label: 'Org name',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Required' },
    },
    {
      key: 'type',
      label: 'Select place type',
      type: 'select_single',
      placement: 'right',
      required: { value: true, err: 'Required' },
      options: []
    },
    {
      key: 'logoUrl',
      label: 'Org logo',
      type: 'input_text',
      placement: 'full',
      required: { value: false, err: 'Required' },
    },
  ],
  orgColTitles: [
    {
      text: 'Name',
      key: 'name',
      type: 'text'
    },
    {
      text: 'Logo',
      key: 'logoUrl',
      type: 'image'
    }
  ],
  popOverFields: [
    {
      key: 'edit',
      title: 'Edit'
    },
    {
      key: 'delete',
      title: 'Delete'
    }

  ],
  popOverFields2: [
    // {
    //   key: 'edit',
    //   title: 'Edit'
    // },
    {
      key: 'delete',
      title: 'Delete'
    }

  ],
  vehiclePopOverFields: [
    {
      key: 'edit-vehicle',
      title: 'Edit'
    },
    {
      key: 'delete-vehicle',
      title: 'Delete'
    }
  ],
  auditPopOverFields: [
    // {
    //   key: 'edit',
    //   title: 'Edit'
    // },
    {
      key: 'delete',
      title: 'Delete'
    },
    {
      key: 'audit',
      title: 'Audit'
    }
  ],
  devicePopOverFieldsAdmin: [
    {
      key: 'edit',
      title: 'Add Org'
    },
    {
      key: 'delete',
      title: 'Delete Device'
    },
  ],
  devicePopOverFieldsOrgAdmin: [
    {
      key: 'edit',
      title: 'Add Place'
    },
  ],
  camConfigPopOverFields: [
    {
      key: 'edit',
      title: 'Edit'
    },
    {
      key: 'delete',
      title: 'Delete'
    },
    {
      key: 'config',
      title: 'Config'
    }
  ],
  camConfigPopOverFieldsEECM: [
    // {
    //   key: 'edit',
    //   title: 'Edit'
    // },
    // {
    //   key: 'delete',
    //   title: 'Delete'
    // },
    // {
    //   key:'historyBrowser',
    //   title:'Open History Browser'
    // },
    // {
    //   key:'liveView',
    //   title:'Open Live View'
    // },
    {
      key: 'subscriptions',
      title: 'Subscriptions'
    }
  ],
  camConfigPopOverFieldsEEVMS: [
    // {
    //   key: 'edit',
    //   title: 'Edit'
    // },
    // {
    //   key: 'delete',
    //   title: 'Delete'
    // },
    {
      key:'historyBrowser',
      title:'Open History Browser'
    },
    {
      key:'liveView',
      title:'Open Live View'
    },
    // {
    //   key: 'subscriptions',
    //   title: 'Subscriptions'
    // }
  ],
  placeTilePopOverFields: [
    {
      key: 'downloadReport',
      title: 'Download Report'
    },
    {
      key: 'edit',
      title: 'Edit'
    },
    {
      key: 'delete',
      title: 'Delete'
    }
  ],
  regularPopOverFields: [
    {
      key: 'viewInfo',
      title: 'View Info'
    },
    {
      key: 'downloadReport',
      title: 'Download Report'
    }
  ],
  userColTitles: [
    {
      type: 'multiple',
      items: [
        {
          text: 'NAME',
          key: 'name',
          type: 'text'
        },
        {
          text: 'E-MAIL ID',
          key: 'email',
          type: 'text'
        },
        {
          text: 'ROLE',
          key: 'role',
          type: 'list'
        }
      ]
    },

  ],
  userColMobileTitles: [
    {
      text: 'User Details',
      key: 'userDetails',
      type: 'text'
    },
  ],
  userColDesktopViewTitles: [
    {
      text: 'E-MAIL ID',
      key: 'email',
      type: 'text'
    },
    {
      text: 'ROLE',
      key: 'role',
      type: 'list'
    },
    {
      text: 'NAME',
      key: 'name',
      type: 'text'
    },
  ],
  deviceColTitles: [
    {
      type: 'multiple',
      items: [
        {
          text: 'Device ID',
          key: 'deviceId',
          type: 'text'
        },
        {
          text: 'NAME',
          key: 'name',
          type: 'text'
        },
        {
          text: 'TYPE',
          key: 'type',
          type: 'text'
        },
      ]
    },
  ],
  deviceColMobileTitles: [
    {
      text: 'Device Details',
      key: 'userDetails',
      type: 'text'
    },
  ],
  deviceColDesktopViewTitles: [
    {
      text: 'Device ID',
      key: 'deviceId',
      type: 'text'
    },
    {
      type: 'multiple',
      text: 'Device Details',
      items: [
        {
          text: 'NAME',
          key: 'name',
          type: 'text'
        },
        {
          text: 'ORG',
          key: 'orgName',
          type: 'text'
        },
        {
          text: 'PLACE',
          key: 'placeName',
          type: 'text'
        },
      ]
    },
    {
      text: 'TYPE',
      key: 'type',
      type: 'text'
    }
  ],
  userFieldEmail: {
    email: {
      key: 'email',
      label: 'Email Address',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Provide your email' },
      email: { value: true, err: 'Provide a valid email' }
    }
  },
  userFields: [
    {
      key: 'email',
      label: 'Email Address',
      type: 'input_text',
      placement: 'left',
      disabled: true,
      required: { value: true, err: 'Provide your email' },
      email: { value: true, err: 'Provide a valid email' }
    },
    {
      key: 'role',
      label: 'Select Role',
      placement: 'right',
      type: 'checkbox',
      required: { value: true, err: 'Provide a role' },
      options: [
        {
          name: 'ADMIN',
          key: 'ADMIN',
        },
        {
          name: 'REGULAR',
          key: 'REGULAR',
        },
        {
          name: 'RESIDENT',
          key: 'RESIDENT',
        }
      ],
    },
    {
      key: 'cred',
      label: 'New Password (required only for password change)',
      type: 'input_text',
      inputHide: true,
      placement: 'full',
      required: { value: false, err: 'Provide a password' },
    },
    {
      key: 'name',
      label: 'Name',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Provide your name' },
    },
    {
      key: 'phone',
      label: 'Phone',
      type: 'input_text',
      placement: 'right',
      required: { value: false, err: 'Provide phone number' },
      phone: { value: true, err: 'Provide a valid phone' },
    },
    {
      key: 'vehicleNumbers',
      label: 'Vehicle Numbers',
      type: 'input_text',
      placement: 'full',
      required: { value: false, err: 'Provide vechicle number' },
    }
  ],
  adminUserFields: [
    {
      key: 'email',
      label: 'Email Address',
      type: 'input_text',
      disabled: true,
      placement: 'left',
      required: { value: true, err: 'Provide your email' },
      email: { value: true, err: 'Provide a valid email' }
    },
    {
      key: 'name',
      label: 'Name',
      type: 'input_text',
      placement: 'right',
      required: { value: true, err: 'Provide your name' },
    },
    {
      key: 'phone',
      label: 'Phone',
      type: 'input_text',
      placement: 'left',
      required: { value: false, err: 'Provide phone number' },
      phone: { value: true, err: 'Provide a valid phone' },
    },
    {
      key: 'cred',
      label: 'Password (required only for password change)',
      type: 'input_text',
      inputHide: true,
      placement: 'right',
      required: { value: false, err: 'Provide a password' },
    }
  ],
  adminAuditFieldConfig: [
    {
      "key": "fromDate",
      "label": "From Date",
      "type": "input_text",
      "inputDate":true,
      "placement": "left",
      "required": {
        "value": true,
        "err": "Provide your from date"
      }
    },
    {
      "key": "toDate",
      "label": "To Date",
      "inputDate":true,
      "type": "input_text",
      "placement": "right",
      "required": {
        "value": true,
        "err": "Required"
      }
    }
  ],
  placeFields: [
    {
      key: 'name',
      label: 'Name',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Required' },
    },
    {
      key: 'type',
      label: 'Select type',
      type: 'select_single',
      placement: 'right',
      required: { value: true, err: 'Required' },
      options: []
    },
    /*{
      key: 'lat',
      label: 'Location Latitude',
      type: 'input_text',
      placement: 'left',
      required: { value: false, err: 'Required' },
    },
    {
      key: 'long',
      label: 'Location longitude',
      type: 'input_text',
      placement: 'right',
      required: { value: false, err: 'Required' },
    },*/
    {
      key: 'logoUrl',
      label: 'Logo link',
      type: 'input_text', // Updated
      placement: 'full',
      required: { value: false, err: 'Required' },
    }
  ],
  camFields: [
    {
      key: 'name',
      label: 'Name',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Required' },
    },
    {
      key: 'type',
      label: 'Select type',
      type: 'select_single',
      placement: 'right',
      required: { value: true, err: 'Required' },
      options: []
    },
    {
      key: 'urlVideo',
      label: 'Camera live video URL',
      type: 'input_text',
      placement: 'left',
      required: { value: false, err: 'Required' },
    },
    {
      key: 'flags',
      label: 'Flags',
      type: 'input_text',
      placement: 'right',
      required: { value: false, err: 'Required' },
    },
    {
      key: 'urlJpeg',
      label: 'Camera live image URL',
      type: 'input_text',
      placement: 'left',
      required: { value: false, err: 'Required' },
    }
  ],

  chartFields: {
    key: 'chartType',
    label: 'Chart Type',
    labelValue: 'chartTypeLabel',
    type: 'checkbox',
    options: [
      {
        name: 'Select All', key: 'selectAll',
        value: "selectAll",
        _id: "selectAll",

      },
      {
        key: "bar",
        value: "bar",
        name: "Bar",
        _id: "bar",
      },
      {
        key: "line",
        value: "line",
        name: "Line",
        _id: "line",
      },
      // {
      //   key: "pie",
      //   value: "pie",
      //   name: "Pie",
      //   _id: "pie",
      // },
      // {
      //   key: "scatter",
      //   value: "scatter",
      //   name: "Scatter",
      //   _id: "scatter",
      // },
      // {
      //   key: "bubble",
      //   value: "bubble",
      //   name: "Bubble",
      //   _id: "bubble",
      // },
      // {
      //   key: "radar",
      //   value: "radar",
      //   name: "Radar",
      //   _id: "radar",
      // },
      // {
      //   key: "doughnut",
      //   value: "doughnut",
      //   name: "Doughnut",
      //   _id: "doughnut",
      // }
    ]
  },

  chartIntervalFields:{
    key: 'chartTime',
    label: 'Chart Time',
    labelValue: 'chartTimeLabel',
    type: 'checkbox',
    options: [
      {
        key: "daily",
        value: "daily",
        name: "Daily",
        _id: "daily",
      },
      {
        key: "hourly",
        value: "hourly",
        name: "Hourly",
        _id: "hourly",
      },
      {
        key: "weekly",
        value: "weekly",
        name: "Weekly",
        _id: "weekly",
      }
    ]
  },
  
  reportFields: {
    selectCam: {
      key: 'selectedCamIds',
      type: 'checkbox',
      options: []
    },
    eventFields: {
      key: 'eventFields',
      label: 'Event fields',
      labelValue: 'eventFieldLabel',
      type: 'text',
      options:[],

    },
    eventImages: {
      key: 'eventImages',
      label: 'Event Images',
      type: 'text',
      options: []
    },
    fromDateTs: {
      key: 'fromDateTs',
      label: 'From',
      type: 'text',
    },
    toDateTs: {
      key: 'toDateTs',
      label: 'To',
      type: 'text'
    }
  },
  violationsField:{
    reasonForViolation: {
      key: 'reasonForViolation',
      label: 'Reason',
      type: 'text',
      options: []
    }
  },
  imageSetFields: [
    {
      key: 'setName',
      label: 'Set Name',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Set name is required' },
    },
    {
      key: 'images',
      label: 'Upload Images',
      type: 'upload_imageV2',
      placement: 'full',
      required: { value: true, err: 'At least one image is required' },
    }
  ],
  userNotificationFields: [

    {
      key: 'name',
      label: 'Name',
      type: 'input_text',
      placement: 'left',
      required: { value: false, err: 'Provide your name' },
    },
    {
      key: "image",
      label: "Image",
      type: "upload_imageV2",
      placement: "full",
      required: {
        value: false,
        err: "Required"
      }
    },
    // {
    //   key: 'type',
    //   label: 'Select type',
    //   type: 'select_single',
    //   placement: 'right',
    //   required: { value: false, err: 'Required' },
    //   options: [{
    //     key: "BLACKLISTED",
    //     value: "BLACKLISTED",
    //     name: "BLOCKED",

    //   }, 
    //   {
    //     key: "WHITELISTED",
    //     value: "WHITELISTED",
    //     name: "AUTHORIZED",

    //   }]
    // },
    {
      key: 'tag',
      label: 'Select Tag',
      type: 'checkbox',
      placement: 'right',
      required: { value: false, err: 'Required' },
      options: [
      {
        key: "EMPLOYEE",
        name: "Employee",
      },
      // {
      //   key: "CUSTOMER",
      //   name: "Customer",
      // },
      {
        key: "VENDOR",
        name: "Vendor",
      },
      {
        key: "SUSPECT",
        name: "Suspect",
      }
     ]
    },
  ],
  eventNotificationFields: [

    {
      key: 'name',
      label: 'Name',
      type: 'autocomplete',
      defaultValue:'',
      placement: 'left',
      required: { value: false, err: 'Provide your name' },
    },
    {
      key: "allImages",
      label: "Image",
      type: "upload_imageV2",
      placement: "full",
      defaultValue:[],
      required: {
        value: false,
        err: "Required"
      }
    },
    // {
    //   key: 'tag',
    //   label: 'Select Tag',
    //   type: 'checkbox',
    //   placement: 'right',
    //   required: { value: false, err: 'Required' },
    //   options: [
    //   {
    //     key: "EMPLOYEE",
    //     name: "Employee",
    //   },
    //   // {
    //   //   key: "CUSTOMER",
    //   //   name: "Customer",
    //   // },
    //   {
    //     key: "VENDOR",
    //     name: "Vendor",
    //   },
    //   {
    //     key: "SUSPECT",
    //     name: "Suspect",
    //   }
    //  ]
    // },
    // {
    //   key: 'type',
    //   label: 'Select type',
    //   type: 'select_single',
    //   placement: 'right',
    //   defaultValue:'',
    //   required: { value: false, err: 'Required' },
    //   options: [{
    //     key: "BLACKLISTED",
    //     value: "BLACKLISTED",
    //     name: "BLOCKED",

    //   }, {
    //     key: "WHITELISTED",
    //     value: "WHITELISTED",
    //     name: "AUTHORIZED",

    //   }
    // ]
    // },
  ],
}

export const liveStreamingIntervals = [
  {
    label: 'LIVE',
    value: 'live'
  },
  {
    label: '00:00 AM',
    value: '00:00'
  },
  {
    label: '03:00 AM',
    value: '03:00'
  },
  {
    label: '06:00 AM',
    value: '06:00'
  },
  {
    label: '09:00 AM',
    value: '09:00'
  },
  {
    label: '12:00 PM',
    value: '12:00'
  },
  {
    label: '03:00 PM',
    value: '15:00'
  },
  {
    label: '06:00 PM',
    value: '18:00'
  },
  {
    label: '09:00 PM',
    value: '21:00'
  },
]
